<template>
  <div>
    <ContentView>
      <template slot="contentBox">
        <!-- <template slot="operate-wrapper">
          <template slot="operateLeft">sdsad</template>
        </template> -->
        <div class="detail-form-box">
          <div class="upload-img-box">
            <div class="upload-img">
              <img :src="form.photo" alt />
            </div>
            <el-upload
              class="upload-demo"
              action
              :before-upload="onProsgress"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
            </el-upload>
          </div>
          <div class="form-box-fr">
            <el-form :model="form">
              <el-form-item label="姓名" :label-width="formLabelWidth">
                <el-input v-model="form.realName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="form.userName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所属企业" :label-width="formLabelWidth">
                <el-input v-if="pageType=='detail'" v-model="form.orgName" autocomplete="off" :disabled="true"></el-input>
                <el-select v-else style="width:100%" @change="orgChange" size="small"  clearable filterable v-model="form.orgCode" placeholder="请选择">
                  <el-option
                    v-for="item in orgList"
                    :key="item.orgCode"
                    :label="item.orgName_Short"
                    :value="item.orgCode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" :label-width="formLabelWidth">
                <el-input v-model="form.departmentName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="职务" :label-width="formLabelWidth">
                <el-input v-model="form.postName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="角色" :label-width="formLabelWidth">
                <!-- <el-input v-model="form.roleName" autocomplete="off"></el-input> -->
                <el-select style="width:100%" v-model="form.roleinfoid" clearable filterable placeholder="请选择">
                  <el-option
                    v-for="item in roleList"
                    :key="item.id"
                    :label="item.roleName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="邮箱" :label-width="formLabelWidth">
                <el-input v-model="form.userEmail" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item v-if="pageType=='detail'" label="注册日期" :label-width="formLabelWidth">
                <el-input v-model="form.registerDate" autocomplete="off" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="帐户状态" :label-width="formLabelWidth">
                <!-- <el-input v-model="sjConfig.userState[form.userState]" autocomplete="off"></el-input> -->
                <el-radio-group v-model="form.userState">
                  <!-- <el-radio :label="idx+''" v-for="(item,idx) in sjConfig.userState" :key="item">
                    {{item}}
                  </el-radio> -->
                  <el-radio :label="0">{{sjConfig.userState['0']}}</el-radio>
                  <el-radio :label="1">{{sjConfig.userState['1']}}</el-radio>
                  <el-radio :label="2">{{sjConfig.userState['2']}}</el-radio>
                  <el-radio :label="3">{{sjConfig.userState['3']}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template slot="pagnation">
        <div>
          <el-button @click="onClose">取 消</el-button>
          <el-button type="primary" @click="onSave">确 定</el-button>
        </div>
      </template>
    </ContentView>
  </div>
</template>
<script>
import ContentView from "@/components/ContentView";
import upDown from "@/utils/upDown";
import apiPub from "@/api/public";
import { mapGetters } from "vuex";
export default {
  name: "enterprise",
  data() {
    return {
      dialogFormVisible: false,
      form: {
        orgCode:"",
        photo:"",
        realName:"",
        postName:"",
        userName:"",
        userState:"",
        roleid:"",
        departmentName:""
      },
      urlData: {},
      formLabelWidth: "80px",
      roleList:[],
      pageType:'add',
      orgList:[],
      options: {
        lable: "",
        value: ""
      }
    };
  },
  components: {
    ContentView
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  created() {
    this.urlData = this.$router.currentRoute.query;
    
    this.getOrg();
    if(this.urlData.id){
      this.init(this.urlData.orgCode)
      this.pageType='detail'
      this.load();
    }
  },
  methods: {
    //---------------查询区域--------begin-----------
    load() {

      var that = this;
      var obj = {
        url: apiPub.GetUserById,
        data: {
          id: this.urlData.id
        }
      };
      $http.request(obj, false, function(res) {
        // console.log(res);
        if (res.code == 200) {
          that.form = res.data;
        }
      });
    },
    init(orgCode){
      const that=this;
      $http.request({
         url:apiPub.GetOrgRoleList,
         data:{
          OrgCode:orgCode||this.currentUser.orgCode
         }},false, function(res) {
        if (res.code == 200) {
          that.roleList = res.data;
        }
      });
    },
    getOrg(){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.GetAllEnterprise,
        "data":{
          SearchText:SearchText,
          pageNum: 0,
          pageSize: 10000,
        }
      };
      $http.request(obj,false,function(res) {
        console.log(res)
        that.orgList=res.data;
      })
    },
    orgChange(code){
      console.log(code)
      this.init(code)
    },
    onProsgress(file) {
      // console.log(file);
      var that = this;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return;
      }
      $http.onUpload("LOGO/" + file.name,file,function(res) {
          console.log(res.linkurl);
          if (res.linkurl) {
            that.form.photo = res.linkurl;
          } else {
            that.form.photo = URL.createObjectURL(file);
          }
        }
      );
    },
    onClose() {
      this.$router.back(-1);
      // this.$router.push({ name: 'enterprise'});
    },
    onSave() {
      var that = this;
      var obj = {
        url: apiPub.AddUserOrg,
        data: {
          Photo:this.form.photo,
          RealName:this.form.realName,
          PostName: this.form.postName,
          UserName: this.form.userName,
          UserEmail: this.form.userEmail,
          UserState:this.form.userState,
          roleid:this.form.roleinfoid,
          DepartmentName:this.form.departmentName,
        }
      };
      if(this.form.id){
        obj.url=apiPub.UpdateUserInfo;
        obj.data.id=this.form.id;
        var message='修改成功';
      }else{
        obj.data.OrgCode=this.form.orgCode
        obj.data.RoleID=this.form.roleinfoid
        var message='添加成功';
      }
      $http.request(obj, false, function(res) {
        // console.log(res);
        if (res.code == 200) {
            that.$message({
                message: message,
                type: 'success'
            });
            that.onClose()
        }
      });
    }
  }
};
</script>